import React from 'react';
import { stringify as stringify$1 } from 'qs';
import { renderToStaticMarkup } from 'react-dom/server';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function isString(v) {
  return typeof v === 'string';
}
function isObject(v) {
  return v && _typeof(v) === 'object' && !Array.isArray(v);
}
function isId(n) {
  return !!(n && String(n).match(/^[0-9]+/));
}
function isUUID(v) {
  return isString(v) && v.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i);
}
function toArray(val) {
  return Array.isArray(val) ? val : [val];
}
function stringify(params, options) {
  return stringify$1(params, _objectSpread2({
    sort: function sort(a, b) {
      return a.localeCompare(b);
    },
    arrayFormat: 'comma',
    encodeValuesOnly: true
  }, options));
}
function parseSchema() {
  var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!isObject(schema)) {
    return {};
  }

  return Object.keys(schema).reduce(function (result, type) {
    var obj = schema[type];

    if (!isObject(obj)) {
      return result;
    }

    result[type] = {
      type: obj.type || type,
      fields: {},
      relationships: {}
    };

    for (var _i = 0, _arr = ['fields', 'relationships']; _i < _arr.length; _i++) {
      var key = _arr[_i];
      var map = obj[key];

      if (isObject(map)) {
        var item = void 0;

        for (var name in map) {
          item = map[name];

          if (isObject(item)) {
            result[type][key][name] = _objectSpread2({}, item);
          } else {
            result[type][key][name] = {
              type: item
            };
          }
        }
      }
    }

    return result;
  }, {});
}
function parseQueryArg(arg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!arg) {
    return {};
  }

  var keys = toArray(arg).reduce(function (acc, val) {
    return acc.concat(isString(val) ? val.split('/').filter(Boolean) : val);
  }, []);
  var id = null;
  var params;

  if (isObject(keys[keys.length - 1])) {
    params = keys.pop();
  }

  var url = "/".concat(keys.join('/'));

  if (params) {
    url += '?';

    if (typeof options.stringify === 'function') {
      url += options.stringify(params, stringify);
    } else {
      url += stringify(params, options.stringify);
    }
  } else {
    params = {};
  }

  var last = keys[keys.length - 1];

  if (isId(last) || isUUID(last)) {
    id = String(keys.pop());
  }

  keys = keys.filter(function (k) {
    return !isId(k) && !isUUID(k);
  });
  return {
    url: url,
    id: id,
    params: params,
    keys: keys
  };
}
function parseTypes(keys) {
  var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var arr = [];
  var ref;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var val = _step.value;

      if (!ref) {
        ref = schema[val];
      } else if (ref.relationships[val]) {
        ref = ref.relationships[val];
      } else {
        ref = null;
      }

      if (ref) {
        arr.push(ref.type);
        ref = schema[ref.type];
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return arr.length ? arr : keys.slice(0, 1);
}
function getTypeMap(query, schema, data) {
  var rels = parseTypes(query.keys, schema);
  var type = rels.pop();

  if (query.params.include) {
    toArray(query.params.include).forEach(function (str) {
      var arr = str.split(',').filter(Boolean);
      arr.forEach(function (path) {
        var types = [type].concat(path.trim().split('.'));
        rels.push.apply(rels, _toConsumableArray(parseTypes(types, schema).slice(1)));
      });
    });
  }

  if (data) {
    mergePayloadTypes(type, data, schema, rels);
  }

  return {
    type: type,
    relationships: rels.filter(function (r, i) {
      return rels.indexOf(r) === i;
    })
  };
}
function mergePayloadTypes(type, data, schema) {
  var types = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var config = schema[type];

  if (!config || !config.relationships) {
    return;
  }

  Object.keys(config.relationships).forEach(function (key) {
    if (data[key]) {
      var rel = config.relationships[key];
      types.push(rel.type);
      mergePayloadTypes(rel.type, data[key], schema, types);
    }
  });
}
function coerceValue(val, type) {
  switch (type) {
    case 'string':
      return String(val || (val === 0 ? 0 : ''));

    case 'number':
      return val ? parseInt(val, 10) : val;

    case 'float':
      return val ? parseFloat(val, 10) : val;

    case 'date':
      return val ? new Date(val) : val;

    case 'boolean':
      return !!val;

    default:
      return val;
  }
}

var Query =
/*#__PURE__*/
function () {
  function Query() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        key = _ref.key,
        cache = _ref.cache,
        timestamp = _ref.timestamp,
        stringify = _ref.stringify;

    _classCallCheck(this, Query);

    this.key = key;
    this.cache = cache;
    this.timestamp = timestamp;
    this.cacheTime = 0;
    this.subscribers = [];
    this.isFetching = false;
    Object.assign(this, parseQueryArg(key, {
      stringify: stringify
    }));
  }

  _createClass(Query, [{
    key: "subscribe",
    value: function subscribe(subscriber) {
      var _this = this;

      this.subscribers.push(subscriber);
      return function () {
        _this.subscribers = _this.subscribers.filter(function (s) {
          return s !== subscriber;
        });
      };
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.subscribers.forEach(function (callback) {
        callback(action);
      });
    }
  }]);

  return Query;
}();

var Serializer =
/*#__PURE__*/
function () {
  function Serializer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        schema = _ref.schema;

    _classCallCheck(this, Serializer);

    this.schema = schema || {};
  }

  _createClass(Serializer, [{
    key: "serialize",
    value: function serialize(type, attrs) {
      var _this = this;

      if (!attrs) {
        return {
          type: type,
          data: null
        };
      }

      if (Array.isArray(attrs)) {
        return {
          data: attrs.map(function (rec) {
            return _this.parseResource(type, rec);
          })
        };
      }

      return {
        data: this.parseResource(type, attrs)
      };
    }
  }, {
    key: "parseResource",
    value: function parseResource(type) {
      var _this2 = this;

      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!attrs) {
        return null;
      }

      attrs = _objectSpread2({}, attrs);

      if (attrs._type) {
        type = attrs._type;
        delete attrs._type;
      }

      var data = {
        type: type
      };
      var rels = {};

      if (attrs.id) {
        data.id = String(attrs.id);
        delete attrs.id;
      }

      var config = this.schema[type];

      if (!config) {
        return _objectSpread2({}, data, {
          attributes: attrs
        });
      }

      var _loop = function _loop(field) {
        if (attrs[field] === undefined) {
          return "continue";
        }

        var ref = config.relationships[field];
        var val = attrs[field];
        delete attrs[field];
        var relType = ref.type || (ref.getType ? ref.getType(attrs) : null);

        if (!ref.readOnly) {
          if (Array.isArray(val)) {
            rels[field] = {
              data: val.map(function (v) {
                return _this2.parseRelationship(relType, v);
              })
            };
          } else {
            rels[field] = {
              data: _this2.parseRelationship(relType, val)
            };
          }
        }
      };

      for (var field in config.relationships) {
        var _ret = _loop(field);

        if (_ret === "continue") continue;
      }

      for (var _field in config.fields) {
        if (config.fields[_field].readOnly) {
          delete attrs[_field];
        } else if (attrs[_field] !== undefined && config.fields[_field].serialize) {
          attrs[_field] = config.fields[_field].serialize(attrs[_field], attrs);
        }
      }

      data.attributes = attrs;

      if (Object.entries(rels).length) {
        data.relationships = rels;
      }

      return data;
    }
  }, {
    key: "parseRelationship",
    value: function parseRelationship(type, attrs) {
      var res = this.parseResource(type, attrs);
      return {
        type: res.type,
        id: res.id || null
      };
    }
  }, {
    key: "deserialize",
    value: function deserialize(res) {
      var _this3 = this;

      if (!res) {
        return null;
      }

      if (res.error) {
        if (isObject(res.error)) {
          return res;
        }

        return {
          error: {
            status: String(res.status || 400),
            title: res.error,
            message: res.error
          }
        };
      }

      if (res.errors) {
        var error = res.errors.find(function (e) {
          return e.status !== '422';
        });
        return error ? {
          error: error
        } : {
          errors: res.errors
        };
      }

      if (!res.data) {
        return res;
      }

      var data = res.data,
          included = res.included,
          rest = _objectWithoutProperties(res, ["data", "included"]);

      if (!Array.isArray(data)) {
        data = [data];
      }

      if (included) {
        data = data.concat(included);
      }

      var fields = {};
      Object.keys(this.schema).forEach(function (ref) {
        fields[ref] = _this3.schema[ref].fields;
      });
      data = data.map(function (rec) {
        var attrs = _objectSpread2({
          id: rec.id
        }, rec.attributes);

        if (fields[rec.type]) {
          var ref;

          for (var field in fields[rec.type]) {
            ref = fields[rec.type][field];

            if (ref.type) {
              attrs[field] = coerceValue(attrs[field], ref.type);
            }

            if (typeof ref.resolve === 'function') {
              attrs[field] = ref.resolve(attrs[field], attrs, rec);
            }
          }
        }

        return _objectSpread2({}, rec, {
          attributes: attrs
        });
      });
      data.forEach(function (rec) {
        if (!rec.relationships) {
          return;
        }

        Object.keys(rec.relationships).forEach(function (key) {
          var rel = rec.relationships[key].data;
          if (!rel) return;

          if (Array.isArray(rel)) {
            rec.attributes[key] = rel.map(function (r) {
              return data.find(function (d) {
                return d.type === r.type && d.id === r.id;
              });
            }).filter(Boolean).map(function (r) {
              return r.attributes;
            });
          } else {
            var child = data.find(function (r) {
              return r.type === rel.type && r.id === rel.id;
            });
            rec.attributes[key] = child ? child.attributes : null;
          }
        });
      });

      if (Array.isArray(res.data)) {
        data = data.reduce(function (acc, rec) {
          return res.data.find(function (r) {
            return r.id === rec.id && r.type === rec.type;
          }) ? acc.concat(rec.attributes) : acc;
        }, []);
      } else {
        data = data.find(function (r) {
          return r.id === res.data.id;
        }).attributes;
      }

      return _objectSpread2({
        data: data
      }, rest);
    }
  }]);

  return Serializer;
}();

var REQUEST_QUERY = 'REQUEST_QUERY';
var RECEIVE_QUERY = 'RECEIVE_QUERY';
var REQUEST_MUTATION = 'REQUEST_MUTATION';
var RECEIVE_MUTATION = 'RECEIVE_MUTATION';

var ApiClient =
/*#__PURE__*/
function () {
  function ApiClient() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        schema = _ref.schema,
        plugins = _ref.plugins,
        config = _objectWithoutProperties(_ref, ["schema", "plugins"]);

    _classCallCheck(this, ApiClient);

    this.subscribers = [];
    this.cache = [];
    this.isMounted = false;
    this.config = _objectSpread2({
      url: null,
      mediaType: 'application/vnd.api+json',
      headers: {},
      cacheTime: 0,
      staleTime: null,
      ssrMode: typeof window === 'undefined',
      formatError: null,
      formatErrors: null,
      stringify: null,
      serialize: function serialize(type, data, schema) {
        return new Serializer({
          schema: schema
        }).serialize(type, data);
      },
      normalize: function normalize(data, schema) {
        return new Serializer({
          schema: schema
        }).deserialize(data);
      }
    }, config, {
      fetch: config.fetch || fetch.bind()
    });

    if (!this.config.url) {
      throw new Error('ApiClient requires a "url"');
    }

    if (schema) {
      this.schema = parseSchema(schema);
    }

    if (plugins) {
      plugins.forEach(function (plugin) {
        plugin.initialize(_this);
      });
    }
  }

  _createClass(ApiClient, [{
    key: "addHeader",
    value: function addHeader(key, value) {
      this.config.headers[key] = value;
      return this;
    }
  }, {
    key: "removeHeader",
    value: function removeHeader(key) {
      delete this.config.headers[key];
      return this;
    }
  }, {
    key: "serialize",
    value: function serialize(type, data) {
      return this.config.serialize(type, data, this.schema);
    }
  }, {
    key: "normalize",
    value: function normalize(data, extra) {
      var result = this.config.normalize(data, this.schema);

      if (!result) {
        return null;
      }

      if (result.error && this.config.formatError) {
        result.error = this.config.formatError(result.error);
      }

      if (result.errors && this.config.formatErrors) {
        result.errors = this.config.formatErrors(result.errors, extra);
      }

      return result;
    }
  }, {
    key: "subscribe",
    value: function subscribe(subscriber) {
      var _this2 = this;

      this.subscribers.push(subscriber);
      return function () {
        _this2.subscribers = _this2.subscribers.filter(function (s) {
          return s !== subscriber;
        });
      };
    }
  }, {
    key: "onError",
    value: function onError(callback) {
      return this.subscribe(function (_ref2) {
        var type = _ref2.type,
            result = _objectWithoutProperties(_ref2, ["type"]);

        if (result.error || result.errors) {
          callback(result);
        }
      });
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.subscribers.forEach(function (callback) {
        return callback(action);
      });
    }
  }, {
    key: "isFetching",
    value: function isFetching() {
      return !!this.cache.find(function (q) {
        return q.isFetching;
      });
    }
  }, {
    key: "isCached",
    value: function isCached(query, cacheTime) {
      if (!query.cache) {
        return false;
      }

      if (!this.isMounted) {
        return true;
      }

      if (query.cache.error || query.cache.errors) {
        return false;
      }

      if (cacheTime * 1000 + query.timestamp > new Date().getTime()) {
        return true;
      }

      return false;
    }
  }, {
    key: "createQuery",
    value: function createQuery(options) {
      return new Query(_objectSpread2({
        stringify: this.config.stringify
      }, options));
    }
  }, {
    key: "getQuery",
    value: function getQuery(query) {
      if (!(query instanceof Query)) {
        query = this.createQuery({
          key: query
        });
      }

      if (!query.url) {
        return query;
      }

      var cached = this.cache.find(function (q) {
        return q.url === query.url;
      });

      if (cached) {
        query = cached;
      } else {
        this.cache.push(query);
      }

      return query;
    }
  }, {
    key: "fetch",
    value: function fetch(queryArg) {
      var _this3 = this;

      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _config$force = config.force,
          _config$cacheTime = config.cacheTime,
          cacheTime = _config$cacheTime === void 0 ? this.config.cacheTime : _config$cacheTime,
          _config$staleTime = config.staleTime,
          staleTime = _config$staleTime === void 0 ? this.config.staleTime : _config$staleTime,
          headers = config.headers,
          hydrate = config.hydrate;
      var query = this.getQuery(queryArg);
      query.cacheTime = Math.max(cacheTime, query.cacheTime);
      query.hydrate = query.hydrate || hydrate;

      if (query.promise) {
        return query.promise;
      }

      if (!config.force && this.isCached(query, cacheTime)) {
        if (staleTime !== null && !this.isCached(query, staleTime)) {
          this.fetch(query, {
            force: true
          });
        }

        return Promise.resolve(this.normalize(query.cache));
      }

      if (query.timeout) {
        clearTimeout(query.timeout);
      }

      query.isFetching = true;
      this.dispatch({
        type: REQUEST_QUERY,
        query: query
      });
      query.dispatch({
        isFetching: true
      });
      var request = this.request(query.url, {
        headers: headers
      });
      query.promise = _asyncToGenerator(function* () {
        query.cache = yield request;
        query.promise = null;
        query.isFetching = false;
        query.timestamp = new Date().getTime();

        var result = _this3.normalize(query.cache);

        _this3.dispatch(_objectSpread2({
          type: RECEIVE_QUERY,
          query: query
        }, result));

        query.dispatch({
          isFetching: false,
          result: result
        });

        if (!_this3.config.ssrMode && !query.subscribers.length) {
          _this3.scheduleGC(query);
        }

        return result;
      })();
      query.promise.abort = request.abort;
      return query.promise;
    }
  }, {
    key: "mutate",
    value: function () {
      var _mutate = _asyncToGenerator(function* (queryArg, data) {
        var _this4 = this;

        var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var query = this.getQuery(queryArg);

        var _getTypeMap = getTypeMap(query, this.schema, data),
            type = _getTypeMap.type,
            relationships = _getTypeMap.relationships;

        var invalidate = config.invalidate,
            options = _objectWithoutProperties(config, ["invalidate"]);

        if (!options.method) {
          options.method = query.id ? 'PATCH' : 'POST';
        }

        if (data && data !== null) {
          data = this.serialize(type, query.id ? _objectSpread2({
            id: query.id
          }, data) : data);
          if (config.customSerializer) {
            data = config.customSerializer(data);
          }
          options.body = JSON.stringify(data);
        }

        this.dispatch(_objectSpread2({
          type: REQUEST_MUTATION
        }, data));
        var result = yield this.request(query.url, options);
        var schema = result;
        result = this.normalize(result, {
          payload: data
        });
        this.dispatch(_objectSpread2({
          type: RECEIVE_MUTATION
        }, result));

        if (!schema.error && !schema.errors) {
          var invalid;

          if (invalidate) {
            invalid = Array.isArray(invalidate) ? invalidate : [invalidate];
          } else if (invalidate !== false) {
            invalid = [type].concat(_toConsumableArray(relationships));
          }

          this.cache.forEach(function (q) {
            if (options.method === 'DELETE' && q.id && query.id === q.id) {
              q.cache = null;
              return;
            }

            if (q.id && q === query && schema.data) {
              q.cache = schema;
              return q.dispatch({
                result: result
              });
            }

            if (!invalid) {
              return;
            }

            if (!q.type) {
              Object.assign(q, getTypeMap(q, _this4.schema));
            }

            var types = [q.type].concat(_toConsumableArray(q.relationships));

            if (types.find(function (t) {
              return invalid.indexOf(t) >= 0;
            })) {
              q.cache = null;

              if (q.subscribers.length) {
                _this4.fetch(q, {
                  force: true
                });
              }
            }
          });
        }

        return result;
      });

      function mutate(_x, _x2) {
        return _mutate.apply(this, arguments);
      }

      return mutate;
    }()
  }, {
    key: "delete",
    value: function _delete(queryArg) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.mutate(queryArg, undefined, _objectSpread2({}, config, {
        method: 'DELETE'
      }));
    }
  }, {
    key: "removeQuery",
    value: function removeQuery(query) {
      this.cache = this.cache.filter(function (q) {
        return q !== query;
      });
    }
  }, {
    key: "scheduleGC",
    value: function scheduleGC(query) {
      var _this5 = this;

      if (query.timeout) return;
      var timestamp = query.timestamp || 0;
      var cacheTime = query.cacheTime || 0;
      var expires = timestamp + cacheTime * 1000;
      var timeout = Math.max(0, expires - new Date().getTime());

      if (timeout) {
        query.timeout = setTimeout(function () {
          _this5.removeQuery(query);
        }, timeout);
      } else {
        this.removeQuery(query);
      }
    }
  }, {
    key: "clearCache",
    value: function clearCache() {
      this.cache.forEach(function (q) {
        q.cache = null;
      });
    }
  }, {
    key: "request",
    value: function request(path) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          url = _ref4.url,
          config = _objectWithoutProperties(_ref4, ["url"]);

      var uri = (url || this.config.url).replace(/\/$/, '') + path;

      var headers = _objectSpread2({
        Accept: this.config.mediaType
      }, this.config.headers);

      if (config.body) {
        headers['Content-Type'] = this.config.mediaType;
      }

      if (config.headers) {
        headers = _objectSpread2({}, headers, {}, config.headers);
      }

      for (var header in headers) {
        if (headers[header] === undefined || headers[header] === null) {
          delete headers[header];
        }
      }

      var options = _objectSpread2({}, this.config.fetchOptions, {}, config, {
        headers: _objectSpread2({}, this.config.headers, {}, headers)
      });

      var abort;

      if (typeof AbortController !== 'undefined') {
        var controller = new AbortController();
        options.signal = controller.signal;

        abort = function abort() {
          return controller.abort();
        };
      }

      var promise = this.config.fetch(uri, options).then(function (res) {
        return res.status === 204 ? {} : res.json();
      })["catch"](function (error) {
        return {
          error: {
            status: String(error.code || 500),
            title: error.message,
            name: error.name
          }
        };
      });

      if (abort) {
        promise.abort = abort;
      }

      return promise;
    }
  }, {
    key: "extract",
    value: function extract() {
      return this.cache.reduce(function (acc, q) {
        if (q.cache && q.hydrate !== false) {
          acc.push([q.key, q.cache]);
        }

        return acc;
      }, []);
    }
  }, {
    key: "hydrate",
    value: function hydrate() {
      var _this6 = this;

      var queries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var timestamp = new Date().getTime();
      queries.forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            cache = _ref6[1];

        _this6.cache.push(_this6.createQuery({
          key: key,
          cache: cache,
          timestamp: timestamp
        }));
      });
    }
  }]);

  return ApiClient;
}();

var ApiContext = React.createContext();
function ApiProvider(_ref) {
  var children = _ref.children,
      config = _objectWithoutProperties(_ref, ["children"]);

  var context = React.useContext(ApiContext);
  config = React.useMemo(function () {
    var result = _objectSpread2({}, context, {}, config);

    if (!result.client) {
      throw new Error('ApiProvider requires a "client" prop');
    }

    if (!result.client instanceof ApiClient) {
      throw new Error('"client" prop must be an ApiClient instance');
    }

    if (context) {
      result.client.isMounted = context.client.isMounted;
    }

    return result;
  }, [context, config.client]);
  React.useEffect(function () {
    config.client.isMounted = true;
  }, []);
  return React.createElement(ApiContext.Provider, {
    value: config,
    children: children
  });
}

function useApiContext() {
  return React.useContext(ApiContext) || {};
}
function useClient() {
  return useApiContext().client;
}
function useIsFetching() {
  var client = useClient();

  var _React$useState = React.useState(function () {
    return client.isFetching();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isFetching = _React$useState2[0],
      setIsFetching = _React$useState2[1];

  React.useEffect(function () {
    return client.subscribe(function () {
      setIsFetching(client.isFetching());
    });
  }, []);
  return isFetching;
}
function useQuery(queryArg, config) {
  var _useApiContext$config = _objectSpread2({}, useApiContext(), {}, config),
      client = _useApiContext$config.client,
      _useApiContext$config2 = _useApiContext$config.ssr,
      ssr = _useApiContext$config2 === void 0 ? client.ssrMode : _useApiContext$config2,
      _useApiContext$config3 = _useApiContext$config.cacheTime,
      cacheTime = _useApiContext$config3 === void 0 ? client.config.cacheTime : _useApiContext$config3,
      _useApiContext$config4 = _useApiContext$config.staleTime,
      staleTime = _useApiContext$config4 === void 0 ? client.config.staleTime : _useApiContext$config4,
      onSuccess = _useApiContext$config.onSuccess,
      onError = _useApiContext$config.onError,
      initialData = _useApiContext$config.initialData,
      hydrate = _useApiContext$config.hydrate;

  var query = client.getQuery(queryArg);
  var stateRef = React.useRef();
  var rerender = React.useReducer(function (i) {
    return ++i;
  }, 0)[1];
  var mountedRef = React.useRef(false);

  var refetch = function refetch() {
    if (!query.url) {
      return null;
    }

    return client.fetch(query, {
      force: true,
      cacheTime: cacheTime,
      hydrate: hydrate
    });
  };

  var setData = function setData(data) {
    data = typeof data === 'function' ? data(stateRef.current.data) : data;
    stateRef.current.data = data;
    rerender();
  };

  React.useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = null;
    };
  }, []);
  React.useMemo(function () {
    if (!query.key) {
      stateRef.current = _objectSpread2({
        data: initialData,
        isLoading: false,
        isFetching: false
      }, stateRef.current);
    } else if (client.isCached(query, cacheTime)) {
      stateRef.current = _objectSpread2({
        isLoading: false,
        isFetching: staleTime !== null && !client.isCached(query, staleTime)
      }, client.normalize(query.cache));
    } else {
      stateRef.current = _objectSpread2({
        data: initialData
      }, stateRef.current, {
        isLoading: true,
        isFetching: true
      });
    }
  }, [query.url]);
  React.useEffect(function () {
    var cleanup = query.subscribe(function (req) {
      var state;

      if (req.result) {
        state = _objectSpread2({
          isLoading: false,
          isFetching: false
        }, req.result);

        if (state.data && onSuccess) {
          onSuccess(req.result);
        } else if (state.error && state.error.name === 'AbortError') {
          state = _objectSpread2({}, stateRef.current, {}, state);
          delete state.error;
        } else if ((state.error || state.errors) && onError) {
          onError(req.result);
        }
      } else if (req.isFetching && !stateRef.current.isFetching) {
        state = _objectSpread2({}, stateRef.current, {
          isFetching: true
        });
      }

      if (state && mountedRef.current) {
        stateRef.current = state;
        rerender();
      }
    });

    if (stateRef.current.isFetching) {
      refetch();
    }

    return function () {
      cleanup();
      client.scheduleGC(query);
    };
  }, [query]);

  if (ssr !== false && client.config.ssrMode && !query.cache) {
    refetch();
  }

  return _objectSpread2({}, stateRef.current, {
    refetch: refetch,
    setData: setData,
    client: client
  });
}
function useMutation(queryArg) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _config$client = config.client,
      client = _config$client === void 0 ? useClient() : _config$client,
      initialData = config.initialData,
      onSuccess = config.onSuccess,
      onError = config.onError,
      options = _objectWithoutProperties(config, ["client", "initialData", "onSuccess", "onError"]);

  var mountedRef = React.useRef(false);
  var query = client.getQuery(queryArg);

  var _React$useState3 = React.useState({
    data: initialData,
    isLoading: false
  }),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      state = _React$useState4[0],
      setState = _React$useState4[1];

  var setData = function setData(data) {
    setState(function (prev) {
      return _objectSpread2({}, prev, {
        data: typeof data === 'function' ? data(state.data) : data
      });
    });
  };

  var setErrors = function setErrors(errors) {
    setState(function (prev) {
      return _objectSpread2({}, prev, {
        errors: typeof errors === 'function' ? errors(state.errors) : errors
      });
    });
  };

  React.useEffect(function () {
    setData(initialData);
  }, [query]);
  React.useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = null;
    };
  }, []);

  var mutate =
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(function* (data) {
      if (state.promise) {
        return state.promise;
      }

      var promise = client.mutate(query, data, options);
      setState(function (prev) {
        return _objectSpread2({}, prev, {
          isLoading: true,
          promise: promise
        });
      });
      var result = yield promise;

      if (mountedRef.current) {
        if (result.data) {
          if (onSuccess) {
            onSuccess(result);
          }

          setState(_objectSpread2({
            isLoading: false
          }, result));
        } else {
          if (onError) {
            onError(result);
          }

          setState(function (_ref2) {
            var promise = _ref2.promise,
                error = _ref2.error,
                errors = _ref2.errors,
                prev = _objectWithoutProperties(_ref2, ["promise", "error", "errors"]);

            return _objectSpread2({}, prev, {}, result, {
              isLoading: false
            });
          });
        }
      }

      return result;
    });

    return function mutate(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [mutate, _objectSpread2({}, state, {
    setData: setData,
    setErrors: setErrors,
    client: client
  })];
}

function renderWithData(_x, _x2, _x3) {
  return _renderWithData.apply(this, arguments);
}

function _renderWithData() {
  _renderWithData = _asyncToGenerator(function* (element, client, config) {
    var _render$config = _objectSpread2({
      render: renderToStaticMarkup
    }, config),
        render = _render$config.render;

    var content = render(element);
    var promises = client.cache.map(function (q) {
      return q.promise;
    }).filter(Boolean);

    if (promises.length) {
      yield Promise.all(promises);
      return renderWithData(element, client, config);
    }

    return [content, client.extract()];
  });
  return _renderWithData.apply(this, arguments);
}

export { ApiClient, ApiProvider, RECEIVE_MUTATION, RECEIVE_QUERY, REQUEST_MUTATION, REQUEST_QUERY, Serializer, renderWithData, useClient, useIsFetching, useMutation, useQuery };
//# sourceMappingURL=index.es.js.map
